import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Product from "@/pages/Product";
import Collection from "@/pages/Collection";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Unsubscribe from "@/pages/Unsubscribe";
import Noise from "@/components/Noise";
import CartDrawer from "@/components/CartDrawer";
import ScrollProgress from "@/components/ScrollProgress";
import DropBanner from "@/components/DropBanner";
import { CartProvider } from "@/lib/cart";
import { ContentProvider } from "@/lib/content";

function App() {
  return (
    <div className="App" style={{ background: "var(--bone)" }}>
      <Noise />
      <Toaster position="bottom-right" theme="dark" />
      <BrowserRouter>
        <ContentProvider>
          <CartProvider>
            <ScrollProgress />
            <CartDrawer />
            <DropBanner />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/product/:slug" element={<Product />} />
            <Route path="/shop/:collection" element={<Collection />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </CartProvider>
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
